// window vars
var g_windowHeight = $(window).height();
var g_windowWidth = $(window).width();

// scroll vars
var g_scroll = $(window).scrollTop();

$(document).ready(mobileBtn);
$(window).resize(mobileBtn);

// set fixed class on Actionbar
function mobileBtn() {
	if(g_windowWidth <= 960) {
		$('body').addClass('body_mobile');
		if($('#actionbar .col-xs-100 .btn-menu').length>0) {
		} else {
			$('#actionbar .page_title').parent().append('<span class="btn btn-white btn-border btn-menu"><i class="icon icon-menu"></i></span>');
		}
	} else {
		$('body').removeClass('body_mobile');
		$('#actionbar .btn-menu').remove();
	}
}

// set fixed class on Actionbar
function fixedMenu() {
    g_scroll = $(window).scrollTop();

	if(g_scroll != 0) {
		$('#actionbar').addClass('fixed');
	} else {
		$('#actionbar').removeClass('fixed');
	}
}


// countdown
var seconds;
var temp;

function countdown() {
    var seconds = $('#countdown').text();
    seconds = parseInt(seconds, 10);

    seconds--;

    if (seconds == 0) {
        $(".alert-success").slideUp();
        setTimeout(function(){
            $(".alert-success").remove();
            $('#countdown').remove();
        }, 1000);
        return;
    }

    $('#countdown').text(seconds);
    $('.autohide-message').text('sluit in '+seconds+' sec.');
    setTimeout(countdown, 1000);
}


// sorteren
function activateSortable() {
    $('.sortable.active ul:first').nestedSortable({
        handle: '.col-handle',
        listType: 'ul',
        items: 'li',
        opacity: .5,
        placeholder: 'placeholder',
        tabSize: 0,
        tolerance: 'pointer',
        toleranceElement: '> div',
        maxLevels: 5,
        revert: 100,
        disableParentChange: true,
        isTree: true,
        stop: function() {
            var sort_data = $(this).nestedSortable('serialize');

            $.ajax({
                type: 'POST',
                data: sort_data,
                url: 'content/ajax-sort/', // create controller action
                cache: false,
                //async: false, // disabled because of db update lag
                dateType: 'json',
                success: function (json_data) {
                    var result;
                    if (json_data.error=='') {
                        result = json_data.status;
                    } else {
                        result = json_data.error;
                    }
                    $('#result_container').html(result);

                },
                error: function (json_data) {
                    $('#result_container').html(json_data.error);
                }
            });

        }
    });
}

function activateLanguageSortable() {
    $('.list-columns').nestedSortable({
        handle: '.col-handle',
        listType: 'ul',
        items: 'li',
        opacity: .5,
        placeholder: 'placeholder',
        tabSize: 0,
        tolerance: 'pointer',
        toleranceElement: '> div',
        maxLevels: 1,
        revert: 100,
        disableParentChange: true,
        isTree: true,
        stop: function() {
            var sort_data = $(this).nestedSortable('serialize');

            $.ajax({
                type: 'POST',
                data: sort_data,
                url: 'language/sort/', // create controller action
                cache: false,
                //async: false, // disabled because of db update lag
                dateType: 'json',
                success: function (json_data) {
                    var result;
                    if (json_data.error=='') {
                        result = json_data.status;
                    } else {
                        result = json_data.error;
                    }
                    $('#result_container').html(result);

                },
                error: function (json_data) {
                    $('#result_container').html(json_data.error);
                }
            });

        }
    });
}


// on document ready
$(function(){

    // on window resize
    $(window).on('resize', function() {
        // set window vars
        g_windowHeight = $(window).height();
        g_windowWidth = $(window).width();
    });


    // on window scroll
    $(window).on('scroll', function(){
        fixedMenu();
    });


    // menu
    fixedMenu();


    // delete-modal
    $(".delete-modal").click(function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var itemName = $(this).data('itemName');

        beConfirm(
            "Je kunt dit niet ongedaan maken.",
            {confirmButtonText: (itemName ? "Ja, verwijder [" + itemName + "]" : "Ja, verwijderen")}
        )
            .then(function () {
                window.location = _BASE_HREF_ + url;
            })
            .catch(swal.noop);
    });


    // fancybox
	$(".fancybox").fancybox();


	// clickable
	$(".clickable").click(function(){
		window.location=$(this).find("a").attr("href");
		return false;
	});


	// fix phalcon value bug
	$("textarea").attr('value', '');


	// toggle menu
	$(document).ready(function() {
		$('body').on('click', '#actionbar .btn-menu', function(event) {
			$('body').addClass('body_mobile_menu');
		});
		$('#page_overlay').on('click', function() {
			$('body').removeClass('body_mobile_menu');
		});
	});

	// menu parent toggle
	$('.cms_menu > li span').on('click', function(e) {
		e.preventDefault();
		$(this).parent().toggleClass('active');
	});


	// footer hover
	$(".footer-section .txt").hover(function() {
		$(this).parent().addClass("hover");
	}, function() {
		$(this).parent().removeClass("hover");
	});


	// set redactor
    $('.redactor-minimal').redactor({
        imageResizable: true,
        imagePosition: true,
        toolbarFixed: false,
        maxHeight: 300,
        minHeight: 100,
        lang: 'nl',
        plugins: ['source'],
        buttonsHide: ['deleted', 'horizontalrule', 'format'],
        linkSize: 1000,
        linkValidation: false
    });
	if(typeof redactor_url_imageUpload != 'undefined') {
        $('.redactor-simple').redactor({
			imageResizable: true,
          	imagePosition: true,
			toolbarFixed: false,
			maxHeight: 300,
            minHeight: 100,
            lang: 'nl',
			plugins: ['properties', 'source'],
            linkSize: 1000,
            linkValidation: false
        });
        $('.redactor').redactor({
			imageResizable: true,
			imagePosition: true,
			toolbarFixed: false,
            maxHeight: 450,
            minHeight: 200,
			linkify: true,
			lang: 'nl',

            imageUpload: redactor_url_imageUpload,
			imageManagerJson: redactor_url_imageGetJson,

			fileUpload: redactor_url_fileUpload,
            fileManagerJson: redactor_url_fileGetJson,

            formatting: ['h1', 'h2', 'h3', 'h4', 'h5', 'p', 'blockquote'],
            formattingAdd: [
                {
                    title: 'Grotere tekst',
					args: ['p', 'class', 'text-large']
                },
                {
					title: 'Kleinere tekst',
					args: ['p', 'class', 'text-small']
                }
            ],
            plugins: ['imagemanager', 'filemanager', 'properties', 'alignment', 'clips', 'source', 'table'],
            linkSize: 1000,
            linkValidation: false
        });
	}


	// add datepicker
	$(".datepicker").flatpickr({
		dateFormat: 'd-m-Y',
		locale: 'nl',
		allowInput: true
	});


	// generic save-form action
	$('.save-form').click(function (e) {
		e.preventDefault();
		var target = $(this).getTarget('#');
        var redirect = $(this).data('redirect');
        if (redirect) {
            $("form#"+target).append('<input type="hidden" name="redirect" value="1">');
        }
		$("form#"+target).submit();
	});


	tabby.init({
		initClass: 'js-tabby',
		callback: function (tabs, toggle){
			/* delete nasty tabby-hash from url */
			history.pushState("", document.title, window.location.pathname + window.location.search);
		}
	});


    // auto hide success messages
    if ($(".alert-success").length>0) {
        $(".alert-success").append('<p class="autohide-message">autoclose</p>');
        $("body").append('<span id="countdown" style="display:none;">10</span>');
        countdown();
    }

	/* table sorting */
    var stupidtableTable = $(".stupidtable").stupidtable();
	stupidtableTable.on("aftertablesort", function (event, data) {
		var th = $(this).find("th");
		var targetTh = data.$th;
		var dir = $.fn.stupidtable.dir;
		var arrow = (data.direction === dir.ASC ? '<i class="icon icon-chevron-small-up"></i>' : '<i class="icon icon-chevron-small-down"></i>');

		/* udate arrows */
		th.find(".arrow").remove();
		targetTh.find(".sort-title").append('<span class="arrow">' + arrow +'</span>');
	});

    // social media share link pop-up
    $('.social-share').click(function(e) {
        e.preventDefault();
        var height = 450;
        var width = 550;
        var top = (screen.height/2)-(height/2);
        var left = (screen.width/2)-(width/2);

        window.open($(this).attr('href'), 'shareWindow', 'height=' + height + ', width=' + width + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        return false;
    });

});

(function () {
    $(function () {
        $("#site_id").change(function (event) {
            event.preventDefault();

            var site_id = input(this);
            location.href = "?_site_id="+(site_id ? site_id : "");
        });
    });

    function input(element)
    {
        var value = $(element).val();
        value = value === "" ? null : value;

        return value;
    }
})();
